const config = {
  // The public origin, the same in every environment: uat canonicals point at
  // production so uat pages are not indexed as themselves.
  SITE_URL: 'https://www.coign.com',
  ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  VERSION: process.env.NEXT_PUBLIC_VERSION || '1.0.0',
  MONITOR_ENV: process.env.NEXT_PUBLIC_MONITOR_ENV,
  DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  DATADOG_APPLICATION_ID: process.env.DATADOG_APPLICATION_ID,
  DATADOG_PROXY_URL: process.env.NEXT_PUBLIC_DATADOG_PROXY_URL,
  APPFLOW_URL:
    process.env.NEXT_PUBLIC_APPFLOW_URL ||
    'https://www.coign.com/applytospendright',
  POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  WEBAPP_URL: process.env.NEXT_PUBLIC_WEBAPP_URL,
  APIGW_URL: process.env.NEXT_PUBLIC_APIGW_URL,
  PLASMIC_PROJECT_ID: process.env.NEXT_PUBLIC_PLASMIC_PROJECT_ID,
  PLASMIC_API_TOKEN: process.env.NEXT_PUBLIC_PLASMIC_API_TOKEN,
  PLASMIC_CACHE_TTL: process.env.PLASMIC_CACHE_TTL || 60 * 60 * 1000,
  PLASMIC_CMS_ID: process.env.NEXT_PUBLIC_PLASMIC_CMS_ID || '',
  PLASMIC_CMS_PUBLIC_TOKEN:
    process.env.NEXT_PUBLIC_PLASMIC_CMS_PUBLIC_TOKEN || '',
  PLASMIC_DONATIONS_CMS_MODEL_ID:
    process.env.NEXT_PUBLIC_PLASMIC_DONATIONS_CMS_MODEL_ID || '',
  DATADOG_API_KEY: process.env.NEXT_PUBLIC_DATADOG_API_KEY,
  POSTHOG_PROXY_URL: process.env.NEXT_PUBLIC_POSTHOG_PROXY_URL,
  PLASMIC_CAUSES_CMS_ID: process.env.NEXT_PUBLIC_PLASMIC_CAUSES_CMS_ID || '',
  PLASMIC_CAUSES_CMS_MODEL_ID:
    process.env.NEXT_PUBLIC_PLASMIC_CAUSES_CMS_MODEL_ID || '',
  PLASMIC_CAUSES_CMS_PUBLIC_TOKEN:
    process.env.NEXT_PUBLIC_PLASMIC_CAUSES_CMS_PUBLIC_TOKEN || '',
  CONTENT_CDN_URL: process.env.NEXT_PUBLIC_CONTENT_CDN_URL || '',
  PUBLIC_REVALIDATION_SECRET: process.env.NEXT_PUBLIC_REVALIDATION_SECRET || '',
  COOKIEBOT_CBID: process.env.NEXT_PUBLIC_COOKIEBOT_CBID,
  GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  PRIVACY_POLICY_VERSION: process.env.NEXT_PUBLIC_PRIVACY_POLICY_VERSION || '1',
};

export default config;
